"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JumpRateModelV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "baseRatePerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "multiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "jumpMultiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "kink_",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "baseRatePerSecond",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "multiplierPerSecond",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "jumpMultiplierPerSecond",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "kink",
                type: "uint256",
            },
        ],
        name: "NewInterestParams",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "baseRatePerSecond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "getBorrowRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserveFactorMantissa",
                type: "uint256",
            },
        ],
        name: "getSupplyRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isInterestRateModel",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "jumpMultiplierPerSecond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "kink",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "multiplierPerSecond",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "secondsPerYear",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "baseRatePerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "multiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "jumpMultiplierPerYear",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "kink_",
                type: "uint256",
            },
        ],
        name: "updateJumpRateModel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "cash",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrows",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "reserves",
                type: "uint256",
            },
        ],
        name: "utilizationRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class JumpRateModelV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, overrides) {
        return super.getDeployTransaction(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, overrides || {});
    }
    deploy(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, overrides) {
        return super.deploy(baseRatePerYear, multiplierPerYear, jumpMultiplierPerYear, kink_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.JumpRateModelV2__factory = JumpRateModelV2__factory;
JumpRateModelV2__factory.bytecode = _bytecode;
JumpRateModelV2__factory.abi = _abi;
//# sourceMappingURL=JumpRateModelV2__factory.js.map